import React from 'react';
import LocationTemplate from './LocationTemplate';

const WadePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Wade"
      stateName="North Carolina"
      countyName="Cumberland"
      zipCodes={["28395"]}
      latitude={35.1601}
      longitude={-78.7406}
      population={556}
      historicalFact="Named after General Wade Hampton, incorporated in 1909 as a farming community."
      nearbyTowns={[
        "Fayetteville, NC",
        "Dunn, NC",
        "Godwin, NC",
        "Autryville, NC",
        "Falcon, NC",
        "Linden, NC",
        "Eastover, NC",
        "Stedman, NC"
      ]}
    />
  );
};

export default WadePage;